/**
 * Hero Slider component
 * 
 * @description
 * <p>Sets up and manages Hero sliders and pips</p>
 * <p>Creates pip elements, shows first slider, and set timer for pip animation and next slide</p>
 * <p>Self-initializes when you include this module.</p>
 * <p>FILE: hero-slider.js</p>
 * 
 * @module hero-slider
 * 
 * @namespace site.header
 */
( /* @lends module:hero-slider */ function(site,$){
	"use strict";
(function($){
	var $dom = {},
		trace = {push: function() {}},
		current = -1,
		times = {
			hide : 6100,
			ready : 1500,
			reset : 1500,
			next: 6400
		},
		pipHTML = '<div class="pip hoverable"  tabindex="0"> <div class="base"> <div class="bar"></div> <div class="circle"></div></div><div class="mask"><div class="progress"><div class="bar"></div><div class="circle"></div></div></div></div>',
		readyTimer,
		resetTimer,
		hideTimer,
		showTimer,
		complete = false;

	/**
	 * Hero Slider Initializer
	 */
	function init() {

		// register modules/libraries for local use
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};
		
		// cache DOM elements
		$dom.header = $(".hero-slider");
		$dom.holder = $('.holder',$dom.header);
		$dom.mask = $('.mask',$dom.header);
		$dom.content = $(".slide",$dom.holder);
		$dom.pips = $(".pips",$dom.holder);
		$dom.videovid = $(".vid",$dom.content)
		// if no content, STOP
		if(!$dom.content.length){
			return;
		}
		
		trace.push('count = '+$dom.content.length);

		generatePips();
		show(current+1);
	}

	/**
	 * Add a pip to the DOM for every slide
	 */
	function generatePips(){
		$dom.content.each(function() {
			$dom.pips.append(pipHTML);
		});

		$dom.pip = $(".pip",$dom.holder);

		$dom.pip.each(function( index ) {
			trace.push('index = '+index);
			$(this).attr('data-id',index);
			$(this).on('click', function(){
				var id = $(this).attr('data-id');
				trace.push('id = '+id);
				clickHandler(id*1);	
			})
		});
	}
	/**
	 * Show the next slide
	 * @param  {integer} index the index of the slide to show
	 */
	function clickHandler(index) {
		trace.push('clickHandler index = '+index+" current = "+current);
		if(index == current || complete == false) return;
		clearTimeout(hideTimer);
		clearTimeout(readyTimer);
		clearTimeout(resetTimer);
		clearTimeout(showTimer);
		hide(current);
		show(index);
		//reset(current);
	}

	/**
	 * Show the next slide
	 * @param  {integer} index the index of the slide to show
	 */
	function show(index) {
		trace.push('show index = '+index);
		complete = false;

		if(index >= $dom.content.length) {
			
			index = 0;
			trace.push('show first = '+$dom.content.length);
		}
		/**$("video").each(function(){
		$(this).get(0).play();
		});**/

		//console.log("show fn", JSON.parse(JSON.stringify($dom.content[index])));
		//console.log("show fn", 'helllo show');

		/**setTimeout(function(){
			$($dom.pip[index]).find('.mask').addClass('active');
		}, 50);**/
		
		current = index;
		

		$($dom.content[index]).addClass('show').addClass('active').removeClass('ready');	
		//$($dom.videovid[index]).addClass('showing');		
		$($dom.pip[index]).find('.mask').addClass('active');		
		//$($dom.content[index]).find('.vid').trigger('play');
		var video_ele = $($dom.content[index]).find('.vid');
		if(video_ele.length  > 0) {
			$($dom.content[index]).find('.vid').get(0).play();
			trace.push('playvideo');
		}
		

		if(!check_ie()){
			//alert('Not IE');
			var video_ele_next = $($dom.content[current]).find('.vid');
			if(video_ele_next.length  > 0) {
				$($dom.content[current]).find('.vid').get(0).currentTime=0;
				trace.push('reset not inIE');
			}
		}
		hideTimer = setTimeout(function(){ hide(index); }, times.hide);	
		readyTimer = setTimeout(function(){ ready(index); }, times.ready);
		showTimer = setTimeout(function(){ show(index+1); }, times.next);
	}

	/**
	 * Hide a slide
	 * @param  {integer} index the index of the slide to hide
	 */
	function hide(index) {
		trace.push('hide index = '+index);
		$($dom.content[index]).removeClass('show').addClass('hide').removeClass('ready');
		$($dom.pip[index]).find('.mask').removeClass('active');
		var video_ele = $($dom.content[index]).find('.vid');
		if(video_ele.length  > 0) {
			$($dom.content[index]).find('.vid').get(0).pause();
			trace.push('pause');
		}
		if(check_ie()){
			var video_ele_next = $($dom.content[current]).find('.vid');
			if(video_ele_next.length  > 0) {
				$($dom.content[current]).find('.vid').get(0).currentTime=0;
				trace.push('reset in IE ');
			}
		}
		//$($dom.videovid[index]).addClass('hiding');
		//$($dom.content[index]).find('.vid').addClass('fhvid').removeClass('fsvid');
		//$($dom.content[index]).find('.vid').trigger('pause');
	
		 //console.log("hide fn", JSON.parse(JSON.stringify($dom.content[index])));
		 //console.log("hide fnwith", $dom.content[index])));
		resetTimer = setTimeout(function(){ reset(index); }, times.reset);
	}

	/**
	 * Reset a slide
	 * @param  {integer} index the index of the slide to reset
	 */
	function reset(index) {
		trace.push('reset index = '+index);
		$($dom.content[index]).removeClass('hide').removeClass('active').removeClass('ready');	
	}

	/**
	 * Mark a slide as ready
	 * @param  {integer} index the index of the slide to mark
	 */
	function ready(index) {
		trace.push('ready index = '+index);
		complete = true;
		$($dom.content[index]).addClass('ready');
	}
	/**
	 * @function site.IE
	 * @description UA Sniff for IE only
	 * @return {bool}
	 * @example <caption>Example JavaScript</caption>
	 * {@lang JavaScript}
	 * 
	 * @public
	 */
	function check_ie() {
		var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
		var msie = ua.indexOf('MSIE '); // IE 10 or older
		var trident = ua.indexOf('Trident/'); //IE 11
		if(msie > 0){
			var checkidval = 1;
		}
		if(trident > 0){
			var checkidval = 1;
		}

		return checkidval;
	}

	/**
	 * @function site.header.canplay 
	 * @description
	 * @param {event} event
	 * @example <caption>JavaScript</caption>
	 * {@lang xml}
	 * <video id="vid01" class="vid" oncanplaythrough="site.header.canplay(event)" autoplay playsinline loop muted>
	 *   <source src="/content/media/about_header.mp4" type="video/mp4">
	 *   Your browser does not support the video tag.
	 * </video>
	 * @public
	 */
	function canplay(event) {
		var vid = $('#'+event.target.id);
		vid.addClass('show');
		vid.parent().parent().addClass('ready');
		//vid.trigger('play');
	}

	// Public API definitions
	site.header = {
		data:[],
		canplay:canplay
	};

	$(function(){
		init();
	});
	})(jQuery);
	
	$(".sideScroller .thumbs").each(function(){
		var divs = $(this).find('a');
		for(var i = 0; i < divs.length; i++) $(divs[i]).remove();
		var i = divs.length;
            if ( i == 0 ) return false;
            while ( --i ) {
               var j = Math.floor( Math.random() * ( i + 1 ) );
               var tempi = divs[i];
               var tempj = divs[j];
               divs[i] = tempj;
               divs[j] = tempi;
             }
        for(var i = 0; i < divs.length; i++) $(divs[i]).appendTo(this);
		console.log("This is error");

	});
	
		$(".hero-slider .holder").each(function(){
			console.log("Hero");
		var divs = $(this).find('.slide');
		for(var i = 0; i < divs.length; i++) $(divs[i]).remove();
		var i = divs.length;
            if ( i == 0 ) return false;
            while ( --i ) {
               var j = Math.floor( Math.random() * ( i + 1 ) );
               var tempi = divs[i];
               var tempj = divs[j];
               divs[i] = tempj;
               divs[j] = tempi;
             }
        for(var i = 0; i < divs.length; i++) $(divs[i]).appendTo(this);
		

	});

	
})(window.site=window.site || {}, jQuery);
